<template>
  <ul class="menu-ul-box">
     <template  v-for="item in menu.children">
    <li class="menu-item-box menu-li" :key="item.path" v-if="!item.hidden">
      <div class="menu-text-box" v-if="item.children&&!item.hideChildrenInMenu">
        <span :class="[isActive(item.path) && 'active','hover-menu']" @click="$router.push(item.path)">{{ item.meta.title }}</span>
        <menu-item class="menu-com" :menu="item"></menu-item>
      </div>
      <span v-else :class="[isActive(item.path) && 'active','hover-menu']" @click="$router.push(item.path)">
        {{ item.meta.title }}</span
      >
    </li>
     </template>
  </ul>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    menu: {
      default: () => {},
    },
  },
  created() {
    // console.log(this.menu, 'menu')
  },
  methods: {
    isActive(route) {
      let routelist = this.$route.path.split('/')
      let routeActivelist = route.split('/')
      return !routeActivelist.some((item, index) => {
        return routeActivelist[index] !== routelist[index]
      })
    },
  },
}
</script>

<style lang="less" scoped>
ul {
  margin: 0;
  padding: 0;
}
li {
  padding: 0;
  margin: 0;
}
.menu-ul-box {
  padding: 8px 0px;
  line-height: normal;
  position: absolute;
  width: max-content;
  height: max-content;
  left: 12px;
  z-index: 999;
  display: inline-flex;
  top: 52px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  background: var(--white-100, #fff);
  box-shadow: 0 3px 14px 2px #0000000d, 0 8px 10px 1px #0000000f, 0 5px 5px -3px #0000001a;
}
.menu-li {
  padding: 0 8px;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  span {
    color: #000000a6;
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    padding: 5px 12px;
    border-radius: 6px;
  }
}
.hover-menu:hover{
   background: var(--grey-4, #0000000a);
}
.active {
  background: var(--Brandblue-1, #e8f3ff) !important;
}

.menu-com {
  display: none;
}
.menu-item-box:hover .menu-com {
  display: block;
  left: 100%;
  top: 0;
}
</style>